import React, { Component } from "react";
import PropTypes from "prop-types";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import SubgridPlaceholder from "@mnjsplatform/components/lib/common/Subgrid/SubgridPlaceholder";
import { unmountSubgrid } from "@mnjsplatform/data/lib/actions/subgridActions";
import formatData, { formatMnDate } from "@mnjsplatform/data/lib/utils/formatData";
import { connect } from "react-redux";
import i18next from "i18next";

class ServicesActEditDocumentsSubgrid extends Component {
  componentWillUnmount() {

    if(this.props.subGridKey)
      this.props.dispatch(unmountSubgrid(this.props.parentDataItem, this.props.subGridKey));

    if(this.props.onClose)
      this.props.onClose(this.props.parentDataItem, this.props.parentRowKey, this.props.subGridKey);
  }

  renderDocumentRow = (row, rowIndex, renderRowDefault, dataItem) => {

    let docNumber = row.DocumentNumber;
    let docDate = formatMnDate(row.DocumentDate);
    let deliveryPeriod = i18next.t("DeliveryPeriod", {
      date: formatMnDate(row.DTOrderDay),
      minTime: formatMnDate(row.DTOrderTimeMin),
      maxTime: formatMnDate(row.DTOrderTimeMax)
    });

    let fiMap = {};

    dataItem.rawData.ResultFieldInfo.forEach((item) => {fiMap[item.Name] = item;});

    return (
      <div className="row col-md-4">
        <div className="col-md-12">
          <div className="card -cdoc mt10" style={{paddingBottom: '7px'}}>
            <div className="card-header" style={{paddingTop: "7px", paddingBottom: "0px"}}>
              <div className="row">
                <div className="col-md-12">
                  <h6>{i18next.t("WaybillNumber", {number: docNumber, date: docDate})}</h6>
                </div>
              </div>
            </div>
            <div className="card-body" style={{paddingTop: "0px", paddingBottom: "0px"}}>

              <div className="row fs15" style={{marginTop: "5px"}}>
                <div className="column col-md-12">
                  <span className="field-title">{fiMap.SrcPointName.Title}:</span>
                  <span>&nbsp;{row.SrcPointName}</span>
                </div>
              </div>
              <div className="row fs15" style={{marginTop: "5px"}}>
                <div className="column col-md-12">
                  <span className="field-title">{fiMap.DstPointName.Title}:</span>
                  <span>&nbsp;{row.DstPointName}</span>
                </div>
              </div>
              <div className="row fs15" style={{marginTop: "5px"}}>
                <div className="column col-md-12">
                  <span className="field-title">{fiMap.Receiver.Title}:</span>
                  <span>&nbsp;{row.Receiver}</span>
                </div>
              </div>
              <div className="row fs15" style={{marginTop: "5px"}}>
                <div className="column col-md-12">
                  <span className="field-title">{fiMap.RegisterDateTime.Title}:</span>
                  <span>&nbsp;{formatMnDate(row.RegisterDateTime)}</span>
                </div>
              </div>
              <div className="row fs15" style={{marginTop: "5px"}}>
                <div className="column col-md-12">
                  <span className="field-title">{i18next.t("Delivery")}</span>
                  <span>&nbsp;{deliveryPeriod}</span>
                </div>
              </div>
              <div className="row fs15" style={{marginTop: "5px"}}>
                <div className="column col-md-12">
                  <span className="field-title">{fiMap.Weight.Title}:</span>
                  <span>&nbsp;{formatData(fiMap.Weight, row.Weight)}</span>
                </div>
              </div>
              <div className="row fs15" style={{marginTop: "5px"}}>
                <div className="column col-md-12">
                  <span className="field-title">{fiMap.GrossCost.Title}:</span>
                  <span>&nbsp;{formatData(fiMap.GrossCost, row.GrossCost)}</span>
                </div>
              </div>
              <div className="row fs15" style={{marginTop: "5px"}}>
                <div className="column col-md-12">
                  <span className="field-title">{fiMap.IsReturned.Title}:</span>
                  {row.IsReturned  === 1
                    ? <span style={{fontWeight: 'bold', color: 'green'}}>&nbsp;{i18next.t("YesButton")}</span>
                    : <span style={{fontWeight: 'bold', color: 'red'}}>&nbsp;{i18next.t("NoButton")}</span>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <SubgridPlaceholder subgridKey={this.props.subGridKey}>
        {(subgridItem) => {

          if(subgridItem.rowsCount() === 0)
            return (
              <div className="row fs15">
                <div className="column col-md-12" style={{textAlign: "center", paddingTop: "15px", paddingBottom: "15px"}}>
                  <span>{i18next.t("GridViewEmptyLabel")}</span>
                </div>
              </div>
            );
          else
            return (
              <GridView dataItem={subgridItem}
                        readOnly
                        renderRow={this.renderDocumentRow}
                        showHeader={false}
                        flexBox
                        flexBoxWidthPercent={100}/>
            );
        }
        }
      </SubgridPlaceholder>
    );
  }
}

ServicesActEditDocumentsSubgrid.propTypes = {
  dispatch: PropTypes.func.isRequired,
  parentDataItem: PropTypes.object.isRequired,
  //subGridItem: PropTypes.object.isRequired,
  subGridKey: PropTypes.string.isRequired,
  parentRowKey: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
};


ServicesActEditDocumentsSubgrid.defaultProps = {
};

function mapStateToProps(state, ownProps) {
  return {};
}

export default connect(mapStateToProps)(ServicesActEditDocumentsSubgrid);